import UnlockUserContainer from "../../Componant/Authentication/UnlockUser";

const UnlockUser = () => {
  return (
    <div className="page-wrapper">
      <UnlockUserContainer />
    </div>
  );
};

export default UnlockUser;
